import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import ProductCard from '../components/ProductCard';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const tankCoverPhotos = [
  '/tank1.jpeg',
  '/tank5.jpeg',
  '/tank6.jpeg',
  '/tank7.jpeg',
  '/tank8.jpeg',
  '/tank9.jpeg',
  '/tank10.jpeg',
  '/tank11.jpeg',
];

const isLaunchLocked = (product) => {
  if (!product.launch_settings) return false;
  const settings = typeof product.launch_settings === 'string' 
    ? JSON.parse(product.launch_settings) 
    : product.launch_settings;
  return settings?.enabled === true && settings?.status === 'locked';
};

export default function AboutOutrans() {
  const navigate = useNavigate();
  const [outranProducts, setOutranProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isInWishlist] = useState(() => new Set());

  useEffect(() => {
    fetchOutranProducts();
  }, []);

  const fetchOutranProducts = async () => {
    try {
      const res = await axios.get(`${API}/products?is_outran=true`);
      const allOutranProducts = res.data.products || [];
      const purchasableOutran = allOutranProducts.filter(p => !isLaunchLocked(p));
      setOutranProducts(purchasableOutran);
    } catch (error) {
      console.error('Error fetching outran products:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddToCart = async (product) => {
    // Implement add to cart logic similar to Home.js
    console.log('Add to cart:', product);
  };

  const handleWishlistToggle = (product) => {
    // Implement wishlist toggle logic
    console.log('Toggle wishlist:', product);
  };

  const renderProductCard = (product, index) => {
    return (
      <ProductCard
        key={product.id}
        product={product}
        badge="Outran"
        badgeClass="bg-[#ffcc32] text-black"
        layout="carousel"
        showStock={false}
        showBadge={true}
        isWishlisted={isInWishlist.has(product.id)}
        onOpen={(p) => navigate(`/products/${p.id}`)}
        onAddToCart={handleAddToCart}
        onWishlistToggle={handleWishlistToggle}
        onLaunchBlocked={(p, launch) => console.log('Launch blocked')}
      />
    );
  };

  return (
    <>
      <SEOHead
        title="OUTRAN Products - Premium Motorcycle Tank Covers"
        description="Discover OUTRAN premium tank covers at RRide Moto Studio. Exclusive design, perfect fit, and maximum protection."
        canonical="/about-outrans"
        pathname="/about-outrans"
      />
      <main className="min-h-screen bg-black text-white pt-20 px-4 pb-16">
        
        {/* Tank Cover Photos Gallery */}
        <section className="max-w-7xl mx-auto mb-16">
          <div className="mb-8">
            <p className="text-[#ffcc32] font-semibold uppercase text-sm tracking-[0.3em] mb-2">
              OUTRAN TANK COVERS
            </p>
            <h1 className="text-4xl md:text-6xl font-light tracking-wider text-white font-[Cormorant_Garamond]">
              Premium Collection
            </h1>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {tankCoverPhotos.map((photo, index) => (
              <motion.div
                key={photo}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="overflow-hidden rounded-xl border border-white/10 bg-white"
              >
                <img 
                  src={photo} 
                  alt={`OUTRAN tank cover ${index + 1}`} 
                  className="aspect-[4/5] h-full w-full object-cover transition duration-500 hover:scale-105" 
                />
              </motion.div>
            ))}
          </div>
        </section>

        {/* OUTRAN Products Section */}
        <section className="max-w-7xl mx-auto">
          <div className="mb-8">
            <p className="text-[#ffcc32] font-semibold uppercase text-sm tracking-[0.3em] mb-2">
              SHOP OUTRAN
            </p>
            <h2 className="text-3xl md:text-5xl font-light tracking-wider text-white font-[Cormorant_Garamond]">
              Available Products
            </h2>
          </div>

          {loading ? (
            <div className="text-center py-12">
              <p className="text-zinc-400">Loading OUTRAN products...</p>
            </div>
          ) : outranProducts.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {outranProducts.map((product, index) => renderProductCard(product, index))}
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-zinc-400">No OUTRAN products available at the moment.</p>
            </div>
          )}
        </section>

      </main>
    </>
  );
}
